import { useEffect, useState } from 'react'

import { useStore } from 'store'
import { ConsumptionDetails } from 'types'

import copy from 'copy.json'
import useIsClientPage from 'hooks/useIsClientPage'
import useIsPublicPage from 'hooks/useIsPublicPage'

import Button from 'components/Button'
import YearSummary from 'components/consumption-details/YearSummary'
import MonthlyDataGraph from 'components/consumption-details/MonthlyDataGraph'
import StyledModal from 'components/layout/StyledModal'

const button = copy.common.button

type Props = {
  demandId: string
  isModalOpen: boolean
  onModalClose: () => void
}

export default function ConsumptionDetailsModal({ demandId, isModalOpen, onModalClose }: Props) {
  const { api } = useStore()
  const isClientPage = useIsClientPage()
  const isPublicPage = useIsPublicPage()
  const [consumptionDetails, setConsumptionDetails] = useState<ConsumptionDetails | null>()

  useEffect(() => {
    if (!demandId || !isModalOpen) return

    const fetchData = async () => {
      const result = await api.getConsumptionDetails(demandId, isClientPage, isPublicPage)

      if (!result) return onModalClose()

      setConsumptionDetails(result)
    }

    fetchData()
  }, [demandId, isModalOpen]) // eslint-disable-line

  return (
    <StyledModal
      isOpen={isModalOpen}
      loading={!consumptionDetails?.yearly_data}
      onClose={onModalClose}
    >
      <h3>{copy.modal.consumption_details.title}</h3>

      {consumptionDetails?.yearly_data && <YearSummary data={consumptionDetails.yearly_data} />}

      {consumptionDetails?.monthly_data && (
        <MonthlyDataGraph data={consumptionDetails.monthly_data} />
      )}

      <Button secondary onClick={onModalClose} style={{ width: '100%', maxWidth: 424 }}>
        {button.close}
      </Button>
    </StyledModal>
  )
}
